/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { RollbackOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Layout, Col, Row } from "antd";
import { Button, Card, Form, Input, Spin } from "antd";
import { Badge, Avatar } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { ADD_USER, IMAGE_BASE_URL } from "../../constants/api";
import ImageSelect from "../images/ImageSelect";

function CustomerAdd() {
  const { Content } = Layout;
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);
  // For Image Selection
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedFileValue, setSelectedFileValue] = useState(null);
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const handleDialogOk = (selectedImage) => {
    if (selectedImage.length > 0) {
      setSelectedImage(selectedImage[0].id);
      setSelectedFileValue(selectedImage[0].filePath);
      form.setFieldsValue({ image: selectedImage[0].filePath });
    } else {
      displayMessage(ERROR_MSG_TYPE, "Image not selected");
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage("");
    setSelectedFileValue(null);
    form.setFieldsValue({ image: "" });
  };

  const saveData = (values) => {
    setIsLoading(true);
    const data = new FormData();
    data.append("name", values.name);
    data.append("email", values.email);
    data.append("password", values.password);
    data.append("mobile", values.mobile);
    data.append("user_type", values.user_type);
    if (selectedImage) {
      data.append("image", selectedImage);
    }
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/customer");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to save Data");
    };
    postAPI(ADD_USER, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Create Customer"
            bordered={false}
            extra={
              <Button
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            }
          >
            <Spin spinning={loading}>
              <Form form={form} layout="vertical" onFinish={saveData}>
                <Form.Item name="user_type" hidden initialValue="customer" />
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <Form.Item
                      name="name"
                      label="Full Name"
                      rules={[
                        {
                          required: true,
                          message: `Name is required!`,
                        },
                        {
                          pattern: /^[a-zA-Z0-9\s,.'-]{3,}$/,
                          message:
                            "Name must be at least 3 characters long and alphanumeric.",
                        },
                      ]}
                    >
                      <Input type={"text"} placeholder="Full Name" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="email"
                      label="Email"
                      rules={[
                        {
                          required: true,
                          message: `Email is required!`,
                        },
                        {
                          pattern:
                            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Please enter a valid email address.",
                        },
                      ]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="mobile"
                      label="Mobile"
                      rules={[
                        {
                          required: true,
                          message: `Mobile is required!`,
                        },
                        {
                          pattern: /^[0-9]{10}$/,
                          message:
                            "Please enter a valid 10-digit mobile number.",
                        },
                      ]}
                    >
                      <Input placeholder="Mobile" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      name="password"
                      label="Password"
                      rules={[{ required: false }]}
                    >
                      <Input type={"password"} placeholder="Password" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      type="file"
                      name="image"
                      label="Image"
                      rules={[{ required: true }]}
                    >
                      <Row>
                        <Col span={selectedImage === "" ? 24 : 15} offset={0}>
                          <Input
                            type="text"
                            readOnly
                            onClick={openDialog}
                            value={
                              selectedImage === ""
                                ? "Click to upload image"
                                : selectedImage
                            }
                            name="myImage"
                            placeholder="Image"
                          />
                        </Col>

                        {selectedImage !== "" ? (
                          <Col span={3} offset={1}>
                            <Badge>
                              <Avatar
                                src={IMAGE_BASE_URL + selectedFileValue}
                                shape="circle"
                                size="default"
                              />
                            </Badge>
                            <DeleteOutlined onClick={removeSelectedImage} />
                          </Col>
                        ) : null}
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Save
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Card>
        </Content>
        <LayoutFooter />
        <ImageSelect
          isOpen={isDialogOpen}
          onClose={closeDialog}
          onOk={handleDialogOk}
          fromMager={false}
        />
      </Layout>
    </>
  );
}
export default CustomerAdd;
